import { render, staticRenderFns } from "./RangeSpecs.vue?vue&type=template&id=5b48da21&scoped=true&"
import script from "./RangeSpecs.vue?vue&type=script&lang=js&"
export * from "./RangeSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48da21",
  null
  
)

export default component.exports